export default __webpack_public_path__ + "static/media/bgprofile.39e186e4.png";